import axios from 'axios';
import { IUserSession } from '../../../@types/employee';
import { IGoogleLogInView } from '../../../@types/model/auth/GoogleLogInView';
import { ILogInView } from '../../../@types/model/auth/LogInView';
import { ISignUpView } from '../../../@types/model/auth/SignUpView';

export default class AuthHttpService {

    public static signUp = async (signUpView : ISignUpView) : Promise<string> => {
        const result = await axios.post(`${API_URL}/v1/Authorisation/SignUp`, signUpView);

        return result.data;
    };

    public static logInManual = async (logInView : ILogInView) : Promise<string> => {
        const result = await axios.post(`${API_URL}/v1/Authorisation/LogIn`, logInView);

        return result.data;
    };

    public static googleLogIn = async (googleLogInView : IGoogleLogInView) : Promise<string> => {
        const result = await axios.post(`${API_URL}/v1/Authorisation/LogInGoogle`, googleLogInView);

        return result.data;
    };

    public static getSession = async () : Promise<IUserSession> => {
        const result = await axios.get(`${API_URL}/v1/Authorisation/GetSession`);

        return result.data;
    };

    public static logout = async () : Promise<void> => {
        await axios.get(`${API_URL}/v1/Authorisation/Logout`);
    };

    public static logoutUsers = async (userIds : Array<number>) : Promise<void> => {
        await axios.post(`${API_URL}/v1/Authorisation/LogoutUsers`, userIds);
    };

    public static requestForgottenPasswordEmail = async (emailOrEmpNumber : string) : Promise<boolean> => {
        const result = await axios.post(`${API_URL}/v1/Right/User/RequestForgottenPasswordEmail`, null, {
            params: {
                emailOrEmpNumber, 
            },
        });

        return result.data;
    };

    public static resetPassword = async (recoveryCode : string, email : string, newPassword : string) : Promise<boolean> => {
        const result = await axios.post(`${API_URL}/v1/Right/User/ResetPassword`, {
            recoveryCode,
            newPassword,
            email,
        });

        return result.data;
    };

}
